import "./OptionGridComponent.scss";
import {IComponentOptions} from "angular";
import {ComponentCallback} from "../../../../types/AngularJS";
import {HistoricalOption} from "../models/HistoricalOption";

export const OptionGrid = "tfOptionGrid";

export function optionGrid(): IComponentOptions {
    return {
        templateUrl: "app/services/option-chain/popup/grid/OptionGridComponent.html",
        bindings: {
            options: "<",
            onSelect: "&"
        },
        controllerAs: "ctrl",
        controller: OptionGridComponentController
    };
}

export class OptionGridComponentController {
    public options: Array<HistoricalOption>;
    public onSelect: ComponentCallback;
}
